@for (section of sections; track $index; let isLast = $last) {
  <div class="sidebar-sections">
    @if (section.title) {
      <div class="section-title">
        <span class="section-title__text body-s bold">{{ section.title }}</span>
      </div>
    }
    <div class="section-items">
      @for (item of section.items; track $index) {
        @if (item.expandable) {
          <div class="sidebar-item-expandable" [class.expanded]="item.expanded">
            <a
              class="sidebar-item"
              [class.has-active-child]="hasActiveChild(item)"
              [routerLink]="item.url || item.uri || null"
              [routerLinkActive]="item.url || item.uri ? 'active' : ''"
              (click)="item.url || item.uri ? onItemClick($event, item) : toggleExpand($event, item)"
              tabindex="0"
              role="button"
            >
              <ptl-sidebar-item-base
                [text]="item.title"
                [icon]="item.icon"
                [size]="'m'"
                [isActive]="isRouteActive(item.url || item.uri || null)"
              ></ptl-sidebar-item-base>
              <ptl-icon
                class="expand-icon"
                [size]="'s'"
                [icon]="LucideChevronDown"
                [class.rotated]="item.expanded"
                (click)="toggleExpand($event, item)"
              ></ptl-icon>
            </a>
            @if (item.expanded && item.children?.length) {
              @if (item.paginatedChildren) {
                <ptl-sidebar-expandable-children
                  [children]="item.children"
                  (childClick)="onItemClick($event.event, $event.item)"
                ></ptl-sidebar-expandable-children>
              } @else {
                <div class="sidebar-children">
                  @for (child of item.children; track $index) {
                    <a
                      class="sidebar-item child-item"
                      [routerLink]="child.opensExternally ? null : child.url || child.uri || null"
                      [routerLinkActive]="child.url || child.uri ? 'active' : ''"
                      (click)="onItemClick($event, child)"
                      tabindex="0"
                      role="button"
                    >
                      <ptl-sidebar-item-base
                        [text]="child.title"
                        [icon]="child.icon"
                        [size]="'m'"
                        [isActive]="isRouteActive(child.url || child.uri || null)"
                      ></ptl-sidebar-item-base>
                    </a>
                  }
                </div>
              }
            }
          </div>
        } @else {
          <a
            class="sidebar-item"
            [routerLink]="item.isBackButton ? null : item.url || item.uri"
            [routerLinkActive]="item.url || item.uri ? 'active' : ''"
            (click)="onItemClick($event, item)"
            tabindex="0"
            role="button"
          >
            @if (!item.isBackButton) {
              <ptl-sidebar-item-base
                [text]="item.title"
                [icon]="item.icon"
                [size]="'m'"
                [isActive]="item.url || item.uri ? isRouteActive(item.url || item.uri) : false"
                [pillCount]="item.badgeCount"
              ></ptl-sidebar-item-base>
            } @else {
              <div class="back-button">
                @if (item.icon) {
                  <ptl-icon [size]="'m'" [icon]="LucideChevronLeft"></ptl-icon>
                }
                <div class="button-title body-s bold">{{ 'translations.global.button.back' | transloco }}</div>
              </div>
            }
          </a>
        }
      }
    </div>

    @if (section.showSeparator && !isLast) {
      <div class="section-separator"></div>
    }
  </div>
}
